import * as React from "react"
import { Link } from "react-router-dom"
import Card from "../../../card"
import DetailServiceModal from "../../../services/detail-service-modal"
import DetailGroupModal from "../../../services/detail-group-modal"
import { DataType } from "./index"
import { FooterItem, LinkFooterItem, ButtonFooterItem } from "../../../card/footer-item"
import { LocalAuthority, Service, ServiceGroup, ElementAnalytiqueBergerLevrault } from "../../../../model"

class ServiceCardComponent extends React.Component<ServiceCardComponentProps> {
	render() {
		return <div>
			{this.props.addService &&
			<DetailServiceModal
				localAuthority={this.props.localAuthority}
				Politique={this.props.Politique}
				loading={this.props.loading}
				groups={this.props.groups}
				servicesBL={this.props.servicesBL}
				onClose={this.props.onCloseAddService}
				onError={this.props.onAddServiceError}
				onServiceCreated={this.props.onServiceCreated}
			/>}

			{this.props.addGroup &&
			<DetailGroupModal
				localAuthority={this.props.localAuthority}
				Politique={this.props.Politique}
				onClose={this.props.onCloseAddGroup}
				onError={this.props.onAddGroupError}
				onGroupCreated={this.props.onGroupCreated}
			/>}

			{this.props.viewGroup &&
			<DetailGroupModal
				group={this.props.viewGroup}
				Politique={this.props.Politique}
				localAuthority={this.props.localAuthority}
				onClose={this.props.onCloseEditGroup}
				onError={this.props.onEditGroupError}
				onGroupUpdated={this.props.onGroupUpdated}
				onGroupDeleted={this.props.onGroupDeleted}
			/>}

			{this.props.viewService &&
			<DetailServiceModal
			localAuthority={this.props.localAuthority}
			loading={this.props.loading}
			groups={this.props.groups}
			Politique={this.props.Politique}
			service={this.props.viewService}
			servicesBL={this.props.servicesBL}
			onClose={this.props.onCloseEditModal}
			onError={this.props.onEditServiceError}
			onServiceUpdated={this.props.onServiceUpdated}
			/>}

			<Card footerItems={this.getFooterItems(this.props)} loading={this.props.loading} paddingless title="Services">
				<table className="is-fullwidth">
					{this.getTableBody(this.props)}
				</table>
			</Card>
		</div>
	}

	private getFooterItems(props: ServiceCardComponentProps): FooterItem[] {
		return [
			{
				content : "Ajouter un service",
				disabled: this.props.loading,
				title   : "Ajouter un service",
				onClick : props.localAuthority ? this.props.onClickAddService : null
			} as ButtonFooterItem,
			{
				content : "Ajouter un groupe",
				disabled: this.props.loading,
				title   : "Ajouter un groupe",
				onClick : props.localAuthority ? this.props.onClickAddGroup : null
			} as ButtonFooterItem,
			{
				content : "Voir plus",
				disabled: this.props.loading,
				title   : "Voir plus de services",
				to      : props.localAuthority ? `/${props.localAuthority.slug}/services` : null,
			} as LinkFooterItem
		]
	}

	private getTableBody(props: ServiceCardComponentProps): JSX.Element {
		if (props.loading) return <tbody><tr><td>Chargement...</td></tr></tbody>
		const services = props.services

		const groups   = props.groups
		return (services && services.length) || (groups && groups.length)
			? <tbody>
					{groups && groups.length
						? groups.sort((a, b) => {
							return a.label > b.label ? 1 : -1
						}).map((row, i) => {
									return (<tr key={i}>
									<td>
										<Link to={`#`} onClick={e => this.props.onClickViewGroup(row, e)}>
											{row.label}
										</Link>
										{services && services.length
										?
											<table>
												<tbody>
													{row.services.map((serviceId, i) => {
														const service = services.find(srvc => srvc.id === serviceId)
															if (service) {
																return (<tr key={i} onClick={e => null}>
																	<td>
																		<Link to={'#'} onClick={e => this.props.onClickViewService(service, e)}>
																			{service.label}
																		</Link>
																	</td>
																</tr>)
													}})}
												</tbody>
											</table>
										: "" }
									</td>
								</tr>)
								})
						: null}
						{props.services && services.length
							? props.services.sort((a, b) => {
								return a.label > b.label ? 1 : -1
							}).map((row, i) => {
								if (!row.serviceGroup) {
									return (<tr key={i}>
										<td>
											<Link to={`#`} onClick={e => this.props.onClickViewService(row, e)}>
												{row.label}
											</Link>
										</td>
									</tr>)
								}
							})
							: <tbody><tr><td>Aucun service enregistré</td></tr></tbody>}
				</tbody>
			: <tbody><tr><td>Aucun service ou groupe de services enregistré</td></tr></tbody>
	}
}

export default ServiceCardComponent

export interface ServiceCardComponentProps {
	addGroup: boolean
	addService: boolean
	data: DataType[]
	groups: ServiceGroup[]
	Politique:any
	loading: boolean
	localAuthority: LocalAuthority
	onAddGroupError(reason: any): void
	onAddServiceError(reason: any): void
	onClickAddService(): void
	onClickAddGroup(): void
	onClickViewGroup(group: ServiceGroup, e: React.SyntheticEvent<Element>): void
	onClickViewService(service: Service, e: React.SyntheticEvent<Element>): void
	onCloseAddService(e: React.SyntheticEvent<Element>): void
	onCloseAddGroup(): void
	onCloseEditModal(): void
	onCloseEditGroup(): void
	onEditGroupError(reason: any): void
	onEditServiceError(reason: any): void
	onGroupCreated(group: ServiceGroup): void
	onGroupUpdated(group: ServiceGroup): void
	onGroupDeleted(group: ServiceGroup): void
	onServiceCreated(service: Service): void
	onServiceUpdated(service: Service): void
	services: Service[]
	servicesBL: ElementAnalytiqueBergerLevrault[]
	viewGroup: ServiceGroup
	viewService: Service
}


// WEBPACK FOOTER //
// ./src/component/local-authority/local-authority-detail/service-card/service-card-component.tsx